import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.error.disclaimer.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    row: {
      alignItems: "center",
    },
    icon: {
      marginRight: spacing.m,
      flexShrink: 0,
    },
    text: {
      fontWeight: 500,
      margin: 0,
    },
  };

  return styles;
};
